import React from 'react';
import _ from 'underscore';
import { LoadDimensionFormatter } from '../../components/modules/master/formatters';
function getLatestStatus(shipment) {
    const timelineArray = _.values(shipment.timeline);
    const sortedEvents = _.sortBy(timelineArray, (e) => e.status.code);
    return _.last(sortedEvents);
}
function getShipmentDetailUrl(shipmentId) {
    return `/shipments/${shipmentId}`;
}
function getLocation(location) {
    if (_.isArray(location)) {
        location = location[0];
    }
    return location.name || location.street;
}
function getLoad(loads) {
    return loads.reduce((rows, load) => {
        rows.push(React.createElement(LoadDimensionFormatter, { quantity: load.quantity, type: load.type, length: load.length, width: load.width, height: load.height, dimensional_units: load.dimensional_units }));
        rows.push(React.createElement("br", null));
        return rows;
    }, []);
}
function getEquipment(equipment) {
    return equipment.reduce((rows, equipment) => {
        rows.push(equipment.equipment_id);
        rows.push(React.createElement("br", null));
        return rows;
    }, []);
}
const shipperHasTag = (shipment, tag, addCondition = true) => {
    var _a;
    return (((_a = shipment === null || shipment === void 0 ? void 0 : shipment.shipper) === null || _a === void 0 ? void 0 : _a.tags) || []).includes(tag) && addCondition;
};
export { getLatestStatus, getShipmentDetailUrl, getEquipment, getLocation, getLoad, shipperHasTag, };
